import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BackendService, CookieService } from '@service';

@Component({
  selector: 'optima-global-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  showBanner: boolean;
  message: string;

  constructor(
    private cookieService: CookieService,
    private backendService: BackendService,
    private translateService: TranslateService,
  ) {
    const hasAcknowledged = this.cookieService.getBannerAcknowledgement();
    this.backendService.getOffHours$().subscribe(value => {
      if (!hasAcknowledged && value) {
        this.displayAlert(
          this.translateService.instant('global_message.off_hours'),
        );
      }
    });
  }

  private displayAlert(message): void {
    this.message = message;
    this.showBanner = true;
  }

  protected hideBanner(): void {
    this.cookieService.setBannerAcknowledgement();
    this.showBanner = false;
  }
}
